import { MapContentLayer } from '../MapContentLayer';
import {LayerSpecification, SymbolLayerSpecification, Map} from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';
import { MapStyles } from '../../../../../configuration/map-styles';
import { MapPreviewComponent } from '../../map-preview.component';

export class StormMarkerLabelLayer extends MapContentLayer {

  constructor(
    source: MapContentSource
  ) {
    super('storm-marker-label-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'symbol',
      source: this.sourceRef.sourceId,
      layout: {
        'icon-image': MapPreviewComponent.LABEL_BACKGROUND,
        'icon-anchor': 'left',
        'icon-text-fit': 'width',
        'icon-text-fit-padding': [0, 10, 0, 20],
        'icon-allow-overlap': true,
        'text-field': ['get', 'title'],
        'text-font': ['literal', ['Roboto']],
        'text-size': 12,
        'text-offset': [2, 0.0],
        'text-anchor': 'left',
        'text-max-width': 12,
        'visibility': 'none',
      },
      paint: {
        'text-opacity': 1.0,
        'text-color': MapStyles.PAUSED_COLOR,
        'icon-opacity': 0.9,
      },
    } as SymbolLayerSpecification;
  }

  toggleVisibility(map: Map, visible: boolean) {
    if (map) {
      map.setLayoutProperty(this.layerId, 'visibility', visible ? 'visible' : 'none');
    }
  }
}
